import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '../../../core/helpers/isMobile';
import { Spine } from '../../../core/classes/spine';
import { loadingStore } from '../../../store/loadingStore';

const boneBGName = 'background';
const boneBarAndLogoName = 'scale2';
const LoadingContent = observer(() => {
  const { progress } = loadingStore;
  const [spine, setSpine] = useState(null);
  const loadingSpineRef = useRef();

  useEffect(() => {
    const loadingSpine = new Spine({ key: 'loading' });
    loadingSpine.play('animation');
    loadingSpineRef.current.x = isMobile() ? window.innerWidth / 2 : 720;
    loadingSpineRef.current.y = isMobile() ? window.innerHeight / 2 : 405;
    if (isMobile()) {
      const boneBG = loadingSpine.skeleton.findBone(boneBGName);
      const boneBarAndLogo = loadingSpine.skeleton.findBone(boneBarAndLogoName);
      if (boneBG) {
        const spineOriginalWidth = loadingSpine.width;
        const spineOriginalHeight = loadingSpine.height;
        const scaleX = window.innerWidth / spineOriginalWidth;
        const scaleY = window.innerHeight / spineOriginalHeight;
        const scaleLogo = Math.min(scaleX, scaleY);
        boneBarAndLogo.scaleX = scaleLogo;
        boneBarAndLogo.scaleY = scaleLogo;
        const scaleBG = Math.max(scaleX, scaleY);
        boneBG.scaleX = scaleBG;
        boneBG.scaleY = scaleBG;
      }
    }
    setSpine(loadingSpine);
    loadingSpineRef.current.addChild(loadingSpine);
  }, []);

  const progressBone = useMemo(() => {
    return spine && spine.skeleton.findBone('progress');
  }, [spine]);

  useEffect(() => {
    if (progressBone) progressBone.scaleX = progress * 0.01;
  }, [progress, progressBone]);

  return (
    <Container>
      <Container ref={loadingSpineRef} />
    </Container>
  );
});
export default LoadingContent;
